var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgNp3 = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 42,
    viewBox: "0 0 30 42",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.397 35.84C.713 35.417.289 34.29.289 33.405c0-1.754 1.55-3.305 3.323-3.305 1.09 0 1.772.203 2.437.868 2.437 2.437 5.317 3.785 9.064 3.785 3.988 0 7.09-2.437 7.09-6v-.204c0-3.987-3.748-6.221-9.286-6.221h-1.551c-1.551 0-3.102-1.33-3.102-2.88 0-.886.425-1.773 1.551-2.862l9.526-9.987H4.701C2.947 6.598 1.6 5.047 1.6 3.496 1.6 1.724 2.947.395 4.7.395h20.603c2.013 0 3.563 1.329 3.563 3.101 0 1.55-.886 2.677-2.012 3.766l-9.526 9.748c6.221.886 11.963 3.988 11.963 11.317 0 7.514-5.742 12.85-14.179 12.85-5.963 0-10.412-2.235-13.716-5.336",
    clipRule: "evenodd"
  })));
};
const Memo = /*#__PURE__*/memo(SvgNp3);
export default Memo;